<script setup lang="ts">
import { computed } from 'vue';
import 'flagpack/src/flagpack.scss';

const props = defineProps<{
    code?: string | null | undefined;
    rounded?: boolean;
    square?: boolean;
    size?: 'lg' | 'md';
}>();

const countryClass = computed(() =>
    props.code ? props.code.toLocaleLowerCase() : undefined
);
</script>

<template>
    <span
        :class="[
            'fp',
            countryClass,
            {
                'fp-rounded': props.rounded,
                'fp-square': props.square,
                'fp-md': props.size === 'md',
                'fp-lg': props.size === 'lg',
            },
        ]"
    />
</template>
